"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var lib_1 = require("../../../../lib");
var index_1 = require("../../index");
var cronEnums_1 = require("../cronEnums");
var Hours = Array.from(Array(24).keys()).map(function (num) { return ({
    value: num.toString(),
    label: num.toString().length === 1 ? "0" + num + ":00" : num + ":00"
}); });
var HoursGenerator = /** @class */ (function (_super) {
    tslib_1.__extends(HoursGenerator, _super);
    function HoursGenerator(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.onChangeHoursOption = function (option) {
            _this.setState({ activeHourButton: option });
            _this.generateCronHours();
        };
        _this.onSelectSpecificHours = function (hours) {
            _this.setState({ specificHours: (hours.length > 0) ? hours : ["0"] });
            _this.generateCronHours();
        };
        _this.onSelectBetweenHoursFrom = function (e) {
            var betweenHourTo = _this.state.betweenHourTo;
            _this.setState({ betweenHourFrom: e.target.value });
            if (Number(betweenHourTo) < Number(e.target.value)) {
                _this.setState({ betweenHourTo: (Number(e.target.value) + 1).toString() });
            }
            _this.generateCronHours();
        };
        _this.onSelectBetweenHoursTo = function (e) {
            _this.setState({ betweenHourTo: e.target.value });
            _this.generateCronHours();
        };
        _this.state = {
            activeHourButton: cronEnums_1.HoursOptions.EveryHour,
            specificHours: ["0"],
            betweenHourFrom: "0",
            betweenHourTo: "23",
            cronHours: "0",
        };
        return _this;
    }
    HoursGenerator.prototype.generateCronHours = function () {
        var _this = this;
        setTimeout(function () {
            switch (_this.state.activeHourButton) {
                case cronEnums_1.HoursOptions.EveryHour:
                    _this.setState({ cronHours: "*" });
                    break;
                case cronEnums_1.HoursOptions.EveryHourBetween:
                    _this.setState({ cronHours: _this.state.betweenHourFrom + "-" + _this.state.betweenHourTo });
                    break;
                case cronEnums_1.HoursOptions.SpecificHour:
                    _this.setState({ cronHours: _this.state.specificHours.join(",") });
                    break;
            }
            _this.props.onGenerate(_this.state.cronHours);
        }, 10);
    };
    HoursGenerator.prototype.render = function () {
        var theme = this.props.theme;
        var _a = this.state, activeHourButton = _a.activeHourButton, specificHours = _a.specificHours, betweenHourFrom = _a.betweenHourFrom, betweenHourTo = _a.betweenHourTo;
        return (React.createElement("div", null,
            React.createElement(lib_1.ButtonsGroup, { active: activeHourButton, onChange: this.onChangeHoursOption, borders: true },
                React.createElement(lib_1.GroupButton, { name: cronEnums_1.HoursOptions.EveryHour }, "Every Hour"),
                React.createElement(lib_1.GroupButton, { name: cronEnums_1.HoursOptions.SpecificHour }, "Specific Hours"),
                React.createElement(lib_1.GroupButton, { name: cronEnums_1.HoursOptions.EveryHourBetween }, "Every Hour Between")),
            activeHourButton === cronEnums_1.HoursOptions.EveryHour && (React.createElement("div", null,
                React.createElement(index_1.Label, { className: theme.label }, "Run Every Hours"))),
            activeHourButton === cronEnums_1.HoursOptions.SpecificHour && (React.createElement("div", null,
                React.createElement(index_1.Label, { className: theme.label }, "Run On Specific Hours"),
                React.createElement(index_1.MultiSelect, { surfaceLevel: 0, maxItems: 3, onSelectionChange: this.onSelectSpecificHours, searchable: true, value: specificHours, multiple: true, allowOnlySameGroupSelection: true },
                    React.createElement(index_1.MultiSelectGroup, { value: "selectAllHours", label: "Select All Hours" }, Hours.map(function (hour) { return (React.createElement(index_1.MultiSelectOption, { key: hour.value, value: hour.value, label: hour.label })); }))))),
            activeHourButton === cronEnums_1.HoursOptions.EveryHourBetween && (React.createElement("div", null,
                React.createElement(index_1.Label, { className: theme.label }, "Run Every Hour Between"),
                React.createElement("div", { className: theme.between },
                    React.createElement(lib_1.FormSelect, { className: theme.select, searchable: true, items: Hours.slice(0, 23), maxItems: 5, value: betweenHourFrom, onChange: this.onSelectBetweenHoursFrom, label: "From Hour" }),
                    React.createElement(lib_1.FormSelect, { className: theme.select, searchable: true, items: Hours.filter(function (num) { return Number(num.value) > Number(betweenHourFrom); }), maxItems: 5, value: betweenHourTo, onChange: this.onSelectBetweenHoursTo, label: "To Hour" }))))));
    };
    HoursGenerator.defaultProps = {};
    return HoursGenerator;
}(React.Component));
exports.default = HoursGenerator;
